<template>
  <div class="charge-detail">
    <div @click="queryBicycleDetail">
      <el-button type="primary">{{ $t('lang.refresh') }}</el-button>
    </div>
    <div class="main-title bbn">
      <p>{{ $t('lang.Equipment Information') }}</p>
    </div>
    <div class="info-box" v-if="deviceInfo.deviceInfo">
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Equipment Number') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.number }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Equipment Type') }}</div>
        <div class="item-content">{{ $t('lang.E-Motorcycle') }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.ECU Number') }}</div>
        <div class="item-content">
          <span>{{ deviceInfo.deviceInfo.udid }}</span>
          <span class="ml10 text-btn" @click="qrcodeDialogVisible = true">{{ $t('lang.View QR code') }}</span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Vehicle Spec') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.specification }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Vehicle Frame Number') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.frameNo }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Linked Account') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.userAccount }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.User Mileage') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.userAccountMileage }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Total Mileage') }}</div>
        <div class="item-content">{{ deviceInfo.deviceInfo.totalMileage }}</div>
      </div>
    </div>
    <div class="main-title bbn">
      <p>{{ $t('lang.ECU Information') }}</p>
    </div>
    <div class="info-box">
      <div class="info-item">
        <div class="item-label">{{ $t('lang.ECU Number') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.udid }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.ECU Manufacturer') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.controllerManufacturer }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Hardware Version') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.hardwareVersion }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Software Version') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.softwareVersion }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.ECU Battery Voltage') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.controllerVoltage }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Current Power') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.currentPower }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Current Power') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.currentPospeedwer }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Online State') }}</div>
        <div class="item-content">
          <span>{{ deviceInfo.centralControllerInfo.onlineStatus }}</span>
          <span class="ml10 text-btn" @click="operateBtnClick('2004')">{{ $t('lang.Restart ECU') }}</span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Started') }}/{{ $t('lang.Locked') }}</div>
        <div class="item-content">
          <span>{{ deviceInfo.centralControllerInfo.bucketLockStatus }}</span>
          <span class="ml10 text-btn" @click="switchLockStatus">{{ $t('lang.Switch') }}</span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Wheel Lock state') }}</div>
        <div class="item-content">{{ deviceInfo.centralControllerInfo.wheelLockStatus }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Speed Limit Gear') }}</div>
        <div class="item-content">
          <el-radio-group @change="operateBtnClick('1000', $event)" v-model="deviceInfo.centralControllerInfo.gearLevelParam" size="small">
            <el-radio-button :label="item.label" v-for="(item, index) in stallList" :key="index"></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Backseat') }}</div>
        <div class="item-content">
          <span>{{ deviceInfo.centralControllerInfo.bucketLockStatus }}</span>
          <span class="ml10 text-btn" @click="operateBtnClick('2005')">{{ $t('lang.Open') }}</span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.ECU Fault Code') }}</div>
        <div class="item-content">
          <el-popover
            placement="right"
            width="400"
            trigger="hover">
            <div v-if="deviceInfo.centralControllerInfo.errorCodeList && deviceInfo.centralControllerInfo.errorCodeList.length">
              <div v-for="(item, index) in deviceInfo.centralControllerInfo.errorCodeList" :key="index">
                {{ item }}
              </div>
            </div>
            <div v-else>{{ $t('lang.No data') }}</div>
            <el-button slot="reference">{{ $t('lang.View') }}</el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="main-title bbn">
      <p>{{ $t('lang.Battery Information') }}</p>
    </div>
    <div class="info-box">
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Number') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.batteryId }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Type') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.batteryType }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Hardware Version') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.hardwareVersion }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Software Version') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.softwareVersion }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Voltage Class') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.batteryStandard }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery SOC') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.soc }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Health') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.soh }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Temperature') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.batteryTemperature }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Voltage') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.currentVoltage }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Current') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.currentElectric }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Charge state') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.chargeMosInstructionStatus }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Discharge state') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.dischargeMosInstructionStatus }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.MOS Temperature') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.mosTemperature }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Charge MOS state') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.chargeMosStatus }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Discharge MOS state') }}</div>
        <div class="item-content">{{ deviceInfo.batteryInfo.dischargeMosStatus }}</div>
      </div>
      <div class="info-item">
        <div class="item-label">{{ $t('lang.Battery Fault Code') }}</div>
        <div class="item-content">
          <el-popover
            placement="right"
            width="400"
            trigger="hover">
            <div v-if="deviceInfo.batteryInfo.batteryErrorCodeList && deviceInfo.batteryInfo.batteryErrorCodeList.length">
              <div v-for="(item, index) in deviceInfo.batteryInfo.batteryErrorCodeList" :key="index">
                {{ item }}
              </div>
            </div>
            <div v-else>{{ $t('lang.No data') }}</div>
            <el-button slot="reference">{{ $t('lang.View') }}</el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('lang.View QR code')" :visible.sync="qrcodeDialogVisible" width="30%">
      <el-image v-if="deviceInfo.deviceInfo" :src="qrCodeUrl"></el-image>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qrcodeDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {electricBicycleOperate, queryElectricBicycleDetail, queryQrCode} from '../../api/deviceManagement';

export default {
  name: 'electricBicycleMgmtDetailViewOther',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      radio3: '',
      qrcodeDialogVisible: false,
      deviceInfo: {
        batteryInfo: {},
        centralControllerInfo: {},
        deviceInfo: {}
      },
      udid: '',
      qrCodeUrl: '',
      qrCode: '',
      dataList: [],
      interval: null,
      interval2: null,
      dialogVisible: false,
      zoom: 15,
      center: [120.15, 30.28],
      markers: [],
      address: '',
      lng: 0,
      lat: 0,
      //档位列表
      stallList: [
        {
          label: '1'
        },
        {
          label: '2'
        },
        {
          label: '3'
        },
        {
          label: '4'
        },
        {
          label: '5'
        },
      ],
      //是否正在操作中的标志
      isOperateLoadingFlag: false,
      timer: null,
      timer2: null,
    }
  },
  watch: {
    editData: {
      handler() {
        this.udid = this.editData.udid;
        this.queryBicycleDetail();
        // this.interval = setInterval(this.queryBicycleDetail, 2000);
      },
      deep: true,
    },
  },
  mounted() {
    clearInterval(this.interval);
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    /**
     * 切换一键锁定
     */
    switchLockStatus() {
      let type = ''
      if(this.deviceInfo.centralControllerInfo.startUpStatusCode == 1) {
        type = '2001'
      } else {
        type = '2000'
      }
      this.operateBtnClick(type)
    },
    /**
     * 点击操作按钮
     */
    operateBtnClick(type, payload) {
      let params = {
        operation: type,
        operationParam: payload || '',
        controllerNo: this.udid
      }
      let self = this;
      this.$confirm(this.$t('lang.Confirm operation') + '?', '', {
        type: 'warning'
      }).then(() => {
        self.electricBicycleOperate(params);
      }).catch(action => {
      });
    },
    /**
     * 操作电动车状态
     * @return {Promise<void>}
     */
    async electricBicycleOperate(params) {
      if(this.isOperateLoadingFlag) {
        this.$message.warning(this.$t('lang.In operation'))
        return
      }
      try {
        this.isOperateLoadingFlag = true
        await electricBicycleOperate(params)
        this.isOperateLoadingFlag = false
        this.$message.success(this.$t('lang.Successful'))
        if(this.timer) {
          clearTimeout(this.timer2)
          clearInterval(this.timer)
          this.timer = null
        }
        this.timer = setInterval(() => {
          this.queryBicycleDetail()
        }, 2000)
        this.timer2 = setTimeout(() => {
          clearInterval(this.timer)
          this.timer = null
        }, 30000)
      } catch (e) {
        this.isOperateLoadingFlag = false
      }
    },
    /**
     * 获取电动车详情
     * @return {Promise<void>}
     */
    async queryBicycleDetail() {
      let params = {
        controllerNo: this.udid
      };
      try {
        const res = await queryElectricBicycleDetail(params)
        this.deviceInfo = res.mdata.electricBicycleDetail;
        this.queryQrCode(this.deviceInfo.deviceInfo.qrCode)
      } catch (e) {
        console.log(e)
      } finally {
        if (this.$route.name !== 'electricBicycleMgmt') {
          clearInterval(this.interval);
        }
      }
    },
    /**
     * 获取二维码
     */
    async queryQrCode(link) {
      const  params = {
        link: link,
      }
      const res = await queryQrCode(params)
      this.qrCodeUrl = res.mdata['qrCode:']
    }
  },
}
</script>
<style lang="scss" scoped>
.main-title {
  position: static;
}

.info-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 40px;

  .info-item {
    display: flex;
    align-items: center;
    flex-basis: 25%;
    margin: 20px 0;

    .item-label {
      margin-right: 10px;
    }
  }
}

.text-btn {
  color: #67aa42;
  cursor: pointer;
}

.bbn {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleDetailViewOther.vue